import axios from "axios";

export const createTicket = async ({ ticket, name, email, phone, eventId, paymentMethod }) => {
  const response = await axios.post("subscriptions", {
    eventId,
    ticket, 
    name,
    email,
    phone,
    paymentMethod
  });

  return response;
};

export const createTicketAdmin = async (eventId, { ticket, name, email, phone, paidBy, willSendEmail }) => {
  const response = await axios.post(`/subscriptions/admin/${eventId}`, {
    eventId,
    ticket, 
    name,
    email,
    phone,
    paidBy,
    willSendEmail
  });

  return response;
};
export const getTicketById = (eventId, ticketId) => axios.get(`/subscriptions/admin/${eventId}/${ticketId}`);
export const updateTicket = (eventId, ticketId, data) => axios.put(`/subscriptions/admin/${eventId}/${ticketId}`, data);
export const deleteTicket = (eventId, ticketId) => axios.delete(`/subscriptions/admin/${eventId}/${ticketId}`);

export const updateSubscription = async (
  id,
  { plateNumber, type, captchaToken }
) => {
  const response = await axios.put(`vehicles/${id}`, {
    plateNumber,
    type,
    captchaToken,
  });

  return response;
};

export const deleteSubscription = async (id) => {
  const response = await axios.delete("vehicles", { data: { id } });
  return response;
};

export const getActiveSubscriptions = async () => {
  const response = await axios.get("subscriptions/actives");

  return response;
};

export const getSubscriptionsByPlateNumber = async ({ plateNumber }) => {
  const response = await axios.get(
    "subscriptions/plates?plateNumber=" + plateNumber
  );
  return response;
};

export const getPassiveSubscriptions = async () => {
  const response = await axios.get("subscriptions/passives");

  return response;
};

export const getSubscriptionById = async (id) => {
  const response = await axios.get(`subscriptions/${id}`);

  return response.data;
};
